import { availabilityOptions } from './Availability.options'
import { AvailabilityParts } from './Availability.parts'

export const Availability = {
  options: availabilityOptions,
  isDisabled: AvailabilityParts.isDisabled,
}
